import 'css-chunk:src/components/accordion-group/accordion-group-component.module.scss';export default {
  "accordion-group": "accordion-group-component_accordion-group__NkLeO"
};